
import { defineComponent, ref, computed, watchEffect, Ref } from "vue";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import useBreakpoints from "@/services/Breakpoints";
import { PeopleEvent } from "@/vue-core/models/PeopleEvent.model";
import { ContactUs } from "@/vue-core/models/ContactUsEvent.model";
import { Footer } from "@/vue-core/models/FooterEvent.model";
import { sanitizeUrl } from "@/services/Sanitizer";

export default defineComponent({
  setup() {
    const store = useStore();
    const { type } = useBreakpoints();
    const router = useRouter();

    const eventData: Ref<PeopleEvent> = computed(
      () => store.getters["user/eventData"]
    );
    const footer: Ref<Footer | null> = ref(null);
    const contactUsInfo: Ref<Array<ContactUs>> = ref([]);
    const isLogged = computed(() => store.getters["user/isLogged"]);

    const sanitizedTwitterUrl = computed(() =>
      sanitizeUrl(footer.value ? footer.value.twitter : "")
    );
    const sanitizedFacebookUrl = computed(() =>
      sanitizeUrl(footer.value ? footer.value.facebook : "")
    );
    const sanitizedWebsiteUrl = computed(() =>
      sanitizeUrl(footer.value ? footer.value.web : "")
    );
    const sanitizedLocationUrl = computed(() =>
      sanitizeUrl(
        `https://www.google.com.mx/maps/place/${footer.value?.eventLatitude},${footer.value?.eventLongitude}`
      )
    );

    watchEffect(() => {
      if (eventData.value.footer) {
        footer.value = eventData.value.footer;
      } else {
        footer.value = null;
      }
      if (eventData.value.contactUsInfo) {
        contactUsInfo.value = eventData.value.contactUsInfo;
      } else {
        contactUsInfo.value = [];
      }
    });

    function goTo(to) {
      if (to === "PrivacyPolicy") {
        router.push({ name: to });
      } else if (to === "RegistrationPolicies") {
        router.push({ name: to });
      } else if (to === "BookingPolicies") {
        router.push({ name: to });
      }
    }
    return {
      footer,
      contactUsInfo,
      store,
      goTo,
      eventData,
      isLogged,
      type,
      sanitizedLocationUrl,
      sanitizedTwitterUrl,
      sanitizedFacebookUrl,
      sanitizedWebsiteUrl,
    };
  },
});
